import AccessCodeViewer from './AccessCodeViewer'

export default AccessCodeViewer
